<template>
  <div class="col-12" @click.stop="">
    <div>
      <h5 class="editor-header">
        {{ isEditing ? $t('orders.edit_geometry') : $t('orders.add_empty_geometry') }}
      </h5>
    </div>
    <div class="row">
      <div class="col-4">
        <span>{{ $t('orders.geometry_name') }}</span>
      </div>
      <div class="col-8">
          <input
              id="name"
              v-model="localName"
              type="text"
              autofocus
              class="form-control form-control-sm"
          />
      </div>
    </div>
    <div
      v-if="!isEditing"
      class="row"
    >
      <div class="col-4 mt-2">
        <span>{{ $t('orders.geometry_color') }}</span>
      </div>
      <div class="col-8 mt-2">
        <color-picker
          ref="color-picker"
          :no-red-color="true"
          :initial-color="localColor"
          @select-color="setColor"
        />
      </div>
    </div>
    <div
      v-if="!isEditing"
      class="row"
    >
      <div class="col-4 mt-2">
        <span>{{ $t('orders.geometry_type') }}</span>
      </div>
      <div class="col-8 mt-2">
          <div id="geometry-radio-slots">
              <div class="form-check" v-for="type in ['Point', 'LineString']" :key="type">
                  <input
                      class="form-check-input"
                      type="radio"
                      :id="'geometry-' + type"
                      name="geometry-type-slots"
                      :value="type"
                      v-model="localGeometryType"
                  />
                  <label class="form-check-label" :for="'geometry-' + type">
                      {{ type === 'Point' ? $t('orders.point_type') : $t('orders.linestring_type') }}
                  </label>
              </div>
          </div>
      </div>
    </div>
    <div>
      <hr>
      <div class="col-2 mt-2">
        <span>{{ $t('orders.geometry_properties') }}</span>
      </div>
      <order-geometry-property-editor
            ref="orderGeometryPropertyEditor"
            :new-properties="localProperties"
            @add-property="addProperty"
            @remove-property="removeProperty"
      />
    </div>
    <div class="col-12 d-flex justify-content-end my-2">
      <button
        class="btn btn-secondary form-button"
        @click.stop="close"
      >
        {{ $t('common.cancel') }}
      </button>
      <button
        class="btn btn-success form-button"
        :disabled="!localName"
        @click.stop="submit"
      >
        {{ isEditing ? $t('common.save') : $t('orders.add_empty_geometry') }}
      </button>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/ColorPicker.vue';
import OrderGeometryPropertyEditor from '@/components/order/OrderGeometryPropertyEditor.vue';

export default {
    name: 'OrderGeometryLayerEditor',
    components: {
        ColorPicker,
        OrderGeometryPropertyEditor,
    },
    props: {
        isEditing: {
            type: Boolean,
            default: false,
        },
        geometryData: {
            type: Object,
            default: null
        },
        excludedFields: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            localName: this.geometryData.name,
            localColor: this.geometryData.color,
            localGeometryType: this.geometryData && this.geometryData.type ? this.geometryData.type : 'LineString',
            localProperties: [],
            loadedGeometry: this.geometryData
        };
    },
    mounted() {
        if (this.geometryData && this.geometryData.geometry && this.geometryData.geometry.features && this.geometryData.geometry.features.length > 0) {
            this.geometryData.geometry.features.forEach(feature => {
                if (feature.properties && typeof feature.properties === 'object') {
                    Object.entries(feature.properties).forEach(([key]) => {
                        if (!this.excludedFields.includes(key) && !this.localProperties.includes(key)) {
                            this.localProperties.push(key);
                        }
                    });
                }
            });
        }
    },
    methods: {
        setColor(color) {
            this.localColor = color;
        },
        addProperty(property) {
            this.localProperties.push(property);
        },
        removeProperty(index) {
            if (index > -1) {
                this.localProperties.splice(index, 1);
            }
        },
        close() {
            this.$emit('close');
        },
        submit() {
            if (this.isEditing) {
                // Update the loaded geometry with the new properties
                if (this.loadedGeometry) {
                    if(this.loadedGeometry.geometry && this.loadedGeometry.geometry.features && this.loadedGeometry.geometry.features.length > 0) {
                        this.loadedGeometry.geometry.features.forEach(feature => {
                            if (feature.properties) {
                                // Delete properties that are not in localProperties
                                Object.keys(feature.properties).forEach(key => {
                                    if (!this.excludedFields.includes(key) &&
                                        !this.localProperties.includes(key)) {
                                        delete feature.properties[key];
                                    }
                                });

                                // Add properties from localProperties that are not in feature.properties
                                this.localProperties.forEach(property => {
                                    if (!feature.properties.hasOwnProperty(property)) {
                                        feature.properties[property] = null;
                                    }
                                });
                            }
                        });

                    }
                    this.loadedGeometry.name = this.localName
                    this.loadedGeometry.color = this.localColor
                }
                this.$emit('submit', this.loadedGeometry)
            } else {
                this.$emit('submit', {
                    name: this.localName,
                    color: this.localColor,
                    type: this.localGeometryType,
                    properties: this.localProperties,
                });
            }

        },
    },
};
</script>

<style scoped>

</style>
